export const PRICE_TRENDS_HEATMAP_STRIP_STYLES = {
  root: "w-full rounded-[16px] bg-white p-6 shadow-ticketon-card",
  header: "mb-4 flex flex-col gap-1",
  title: "text-[18px] md:text-[22px] font-bold text-ticketon-dark-blue",
  description: "text-[13px] md:text-[14px] text-ticketon-gray-600",
  strip:
    "grid grid-flow-col auto-cols-fr gap-1 overflow-hidden rounded-lg border border-ticketon-light-border",
  cell: "relative flex h-16 flex-col items-center justify-center px-1 text-center transition-transform hover:scale-[1.02]",
  cellMonth: "text-[11px] md:text-[12px] font-semibold uppercase tracking-wide",
  cellPrice: "mt-0.5 text-[10px] md:text-[11px] font-medium tabular-nums",
  marker:
    "absolute top-1 right-1 inline-flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold text-white",
  markerMin: "bg-ticketon-green",
  markerMax: "bg-ticketon-red-alt",
  legend: "mt-4 flex flex-wrap items-center gap-3 text-[12px]",
  legendItem: "inline-flex items-center gap-1.5 text-ticketon-gray-600",
  legendSwatch: "inline-block h-3 w-3 rounded-sm",
  legendSwatchMin: "bg-ticketon-green",
  legendSwatchMax: "bg-ticketon-red-alt",
} as const;

export const PRICE_TRENDS_HEATMAP_HUE_MIN = 140;
export const PRICE_TRENDS_HEATMAP_HUE_MAX = 0;
